import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDatepicker, MatDatepickerInputEvent, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';
import { DateTime, Duration } from 'luxon';
import { HttpService } from 'src/app/http.service';
import { SnackbarService } from 'src/app/snackbar.service';
@Component({
  selector: 'app-add-attendance',
  templateUrl: './add-attendance.component.html',
  styleUrls: ['./add-attendance.component.scss']
})
export class AddAttendanceComponent implements OnInit {

  @ViewChild('picker', { static: true }) _picker: MatDatepicker<Date>;
  public CLOSE_ON_SELECTED = false;
  public init = new Date();
  public resetModel = new Date(0);
  public model = [];
  leave_types = [
    { name:'Paid Leave',value:'paid_leave'},
    { name:'Absent',value:'absent'},
    { name:'Holiday',value:'holiday'},
  ];
  description = '';
  selectedLeaveType:any = [];
  showLoader = false;
  constructor(private snackbar:SnackbarService,private translation:TranslateService,private http:HttpService, private dialog: MatDialogRef<AddAttendanceComponent>,@Inject(MAT_DIALOG_DATA) private parentData:any) { }

  ngOnInit() {
  }

  submit(){
    let dates = this.model.map((date)=>{
        const t2: any = DateTime.fromJSDate(date).toFormat('yyyy-MM-dd');
        return t2;
    });
    const payload = {
      driver:this.parentData._id,
      dates:dates,
      comment:this.description,
      status:this.selectedLeaveType.value
    }

    if(!payload.dates.length){
      this.snackbar.openSnackBar(this.translation.instant('MESSAGE.DRIVERS.DRIVER_ADD.VALIDATION.NO_DATES'),'','err');
      return;
    }else if(!payload.status){
      this.snackbar.openSnackBar(this.translation.instant('MESSAGE.DRIVERS.DRIVER_ADD.VALIDATION.LEAVE_TYPE'),'','err');
      return;
    }else if(!payload.comment){
      this.snackbar.openSnackBar(this.translation.instant('MESSAGE.DRIVERS.DRIVER_ADD.VALIDATION.COMMENT'),'','err');
      return;
    }else{
      this.showLoader = true;
      this.http.post('driver/mark_fleet_attendance',payload,3).subscribe((response:any)=>{
        this.showLoader = false;
        if(response.statusCode == 200){
          this.snackbar.openSnackBar(this.translation.instant('MESSAGE.DRIVERS.DRIVER_ADD.SUCCESS.ATTENDANCE'));
          this.closeDialog(response);
        }
      },
      (err)=>{
        this.showLoader = false;
        this.snackbar.openSnackBar(err.error.message,'','err');
      })
    }
  }

  public dateClass = (date: Date) => {
    if (this._findDate(date) !== -1) {
      return [ 'selected' ];
    }
    return [ ];
  }

  public dateChanged(event: MatDatepickerInputEvent<Date>): void {
    if (event.value) {
      const date = event.value;
      const index = this._findDate(date);
      if (index === -1) {
        this.model.push(date);
      } else {
        this.model.splice(index, 1)
      }
      this.resetModel = new Date(0);
      if (!this.CLOSE_ON_SELECTED) {
        const closeFn = this._picker.close;
        this._picker.close = () => { };
        this._picker['_popupComponentRef'].instance._calendar.monthView._createWeekCells()
        setTimeout(() => {
          this._picker.close = closeFn;
        });
      }
    }
  }

  public remove(date: Date): void {
    const index = this._findDate(date);
    this.model.splice(index, 1)
  }

  private _findDate(date: Date): number {
    return this.model.map((m) => +m).indexOf(+date);
  }

  selectLeaveType(type){
    this.selectedLeaveType = type;
  }

  closeDialog(data:any = {}){
    this.dialog.close(data);
  }

}
